import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  error: null,
};

const reviewsSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {
    loadReviewsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadReviewsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.reviews = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadReviewsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    updateReviewsRequested(
      state,
      action: PayloadAction<{
        id: any;
        status: any;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    updateReviewsSuccess(
      state,
      action: PayloadAction<{  }>
    ) {
      state.loading = false;
      state.error = null;
      state.updateReviews = action?.payload;
    },
    updateReviewsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadReviewsRequested,
  loadReviewsSuccess,
  loadReviewsFail,
  updateReviewsRequested,
  updateReviewsSuccess,
  updateReviewsFail,
} = reviewsSlice.actions;

export default reviewsSlice.reducer;
